/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
export const checklistReducerConstant = {
  COMPLETE_TREE: 'COMPLETE_TREE',
  MODEL_LIST: 'MODEL_LIST',
  LIST: 'LIST',
  RENAME_LIST: 'RENAME_LIST',
  COMPLETED_PROJECTS: 'COMPLETED_PROJECTS',
  COMPLETED_CHECKLIST_LIST: 'COMPLETED_CHECKLIST_LIST',
  COMPLETED_SECTION_LIST: 'COMPLETED_SECTION_LIST',
  CHECKLIST_LIST: 'CHECKLIST_LIST',
  ASSEMBLY_LIST: 'ASSEMBLY_LIST',
  TOGGLE_INDICATOR: 'TOGGLE_INDICATOR',
  ADD_MODEL_LIST: 'ADD_MODEL_LIST',
  ADD_CHECKLIST_LIST: 'ADD_CHECKLIST_LIST',
  ADD_SECTION_LIST: 'ADD_SECTION_LIST',
  ADD_TASK_LIST: 'ADD_TASK_LIST',
  ADD_ASSEMBLY_LIST: 'ADD_ASSEMBLY_LIST',
  ADD_COMPONENT_LIST: 'ADD_COMPONENT_LIST',
  CHECKLIST_REPORTS_FOR_DELETE: 'CHECKLIST_REPORTS_FOR_DELETE',
  SEVERITY_RATING_SET_LIST: 'SEVERITY_RATING_SET_LIST',
  REPORTS_BY_SEVERITY: 'REPORTS_BY_SEVERITY',
  REPORTS_FOR_ARCHIVED: 'REPORTS_FOR_ARCHIVED',
};
